import { i18n as _i18n } from "@lingui/core";
import { formNames, MktSelectors } from '@wkda/carlead-creation-form';
import { useModulesStore } from '@wkda/funnel-components';
import { BaseField } from '../BaseField';
import { useAutoSelectForDataFields, useSyncValues } from '../hooks/useAutoSelectForDataFields';
import { useDynamicCartypesFetcher } from '../hooks/useDynamicCartypesFetcher';
import { useStateMachineForDataFields } from '../hooks/useStateMachineForFields';
import { useDataWithMissingValue } from './useDataWithMissingValue';
import { selectFieldRenderer } from '../fieldRenderers/selectFieldRenderer';
import { jsx as _jsx } from "react/jsx-runtime";
export function LPSearchMainTypeDetails(_ref) {
  let {
    label = _i18n._(
    /*i18n*/
    {
      id: 'carleadCreation.form.label.mainTypeDetail'
    }),
    placeholder = _i18n._(
    /*i18n*/
    {
      id: 'carleadCreation.form.placeholder.mainTypeDetail'
    }),
    extraLabel = _i18n._(
    /*i18n*/
    {
      id: 'carleadCreation.form.placeholder.extraLabel',
      message: "i don't know"
    }),
    className,
    onChange,
    ...props
  } = _ref;
  const name = formNames.mainTypeDetail;
  const {
    carTypesModule: {
      getMainTypesDetails
    }
  } = useModulesStore();
  const {
    isFieldEnabled,
    sendUserSelect,
    stateFieldClassNames,
    fieldFetchParams
  } = useStateMachineForDataFields({
    name
  });
  const {
    data
  } = useDynamicCartypesFetcher({
    name,
    enabled: isFieldEnabled,
    queryFn: getMainTypesDetails,
    //@ts-expect-error TODO: better type context values
    params: fieldFetchParams,
    responseTransformConfig: {
      orderBy: ''
    }
  });
  const newData = useDataWithMissingValue(name, extraLabel, data);
  useAutoSelectForDataFields(name, newData);
  useSyncValues(name);
  return /*#__PURE__*/_jsx(BaseField, {
    label: label,
    name: name,
    MktSelector: MktSelectors.mainTypeDetail,
    topContainerClassName: stateFieldClassNames,
    renderFieldComponent: function fieldRenderer(_ref2) {
      let {
        name
      } = _ref2;
      return selectFieldRenderer({
        name,
        placeholder,
        className,
        options: newData,
        onChange(evt) {
          onChange === null || onChange === void 0 || onChange(evt);
          sendUserSelect(evt.target.value);
        }
      });
    },
    ...props
  });
}